// Words inside a package name that must be pluralized based on the package quantity
export const PLURALIZE_PACKAGE_NAME_WORDS = ['Pass', 'Cabana'];
